import { IconDefinition } from '@fortawesome/fontawesome-common-types';
import { Store } from '@ngxs/store';
import { Observable, of } from 'rxjs';
import { WellKnownIconsEnum } from 'src/app/helper/iconHelper';
import { SamwinSkillsState } from 'src/app/store/samwin/samwin-skills/samwin-skills.state';
import { EmailTemplateShortInfoRemoteDto } from 'src/generated/signalR/email-template-short-info-remote-dto';
import { SamwinCallInfoRemoteDto } from 'src/generated/signalR/samwin-call-info-remote-dto';
import { AttachmentRemoteDto, EmailsService } from 'src/generated/swagger';
import { EmailTemplateRemoteDto } from 'src/generated/swagger/model/emailTemplateRemoteDto';
import { Enum, EnumType } from 'ts-jenum';

@Enum<EmailPurpose>('name')
export class EmailPurpose extends EnumType<EmailPurpose>() {
   static readonly COMPOSE_EMAIL = new EmailPurpose(
      'COMPOSE_EMAIL',
      true,
      WellKnownIconsEnum.EMAILING_COMPOSE.icon,
      'samwin.email_dialog.email.title',
      'samwin.email_dialog.email.info_text',
      (store, skillId) => {
         return of(store.selectSnapshot(SamwinSkillsState.getSkill(skillId)).skillConfiguration.emailTemplates);
      },
      (
         store: Store,
         emailService: EmailsService,
         mailTemplate: EmailTemplateRemoteDto,
         connectorId: number,
         call: SamwinCallInfoRemoteDto,
         skillId: number,
         context: any,
         attachments: Array<AttachmentRemoteDto>
      ) => {
         return emailService.sendEmail({
            connectorId: connectorId,
            from: mailTemplate.from,
            to: mailTemplate.to.split(';'),
            cc: mailTemplate.cc.split(';'),
            bcc: mailTemplate.bcc.split(';'),
            body: mailTemplate.body,
            subject: mailTemplate.subject,
            callId: call?.callId ?? 0,
            queueId: skillId,
            attachments: attachments,
         });
      }
   );

   static readonly REPLY = new EmailPurpose(
      'REPLY',
      true,
      WellKnownIconsEnum.EMAILING_REPLY.icon,
      'samwin.email_dialog.email.title',
      'samwin.email_dialog.email.info_text',
      (store, skillId) => {
         return of(store.selectSnapshot(SamwinSkillsState.getSkill(skillId)).skillConfiguration.emailTemplates);
      },
      (
         store: Store,
         emailService: EmailsService,
         mailTemplate: EmailTemplateRemoteDto,
         connectorId: number,
         call: SamwinCallInfoRemoteDto,
         skillId: number,
         context: any,
         attachments: Array<AttachmentRemoteDto>
      ) => {
         return emailService.sendEmail({
            connectorId: connectorId,
            from: mailTemplate.from,
            to: mailTemplate.to.split(';'),
            cc: mailTemplate.cc.split(';'),
            bcc: mailTemplate.bcc.split(';'),
            body: mailTemplate.body,
            subject: mailTemplate.subject,
            callId: call?.callId ?? 0,
            queueId: skillId,
            attachments: attachments,
         });
      }
   );

   static readonly REPLY_ALL = new EmailPurpose(
      'REPLY_ALL',
      true,
      WellKnownIconsEnum.EMAILING_REPLY_ALL.icon,
      'samwin.email_dialog.email.title',
      'samwin.email_dialog.email.info_text',
      (store, skillId) => {
         return of(store.selectSnapshot(SamwinSkillsState.getSkill(skillId)).skillConfiguration.emailTemplates);
      },
      (
         store: Store,
         emailService: EmailsService,
         mailTemplate: EmailTemplateRemoteDto,
         connectorId: number,
         call: SamwinCallInfoRemoteDto,
         skillId: number,
         context: any,
         attachments: Array<AttachmentRemoteDto>
      ) => {
         return emailService.sendEmail({
            connectorId: connectorId,
            from: mailTemplate.from,
            to: mailTemplate.to.split(';'),
            cc: mailTemplate.cc.split(';'),
            bcc: mailTemplate.bcc.split(';'),
            body: mailTemplate.body,
            subject: mailTemplate.subject,
            callId: call?.callId ?? 0,
            queueId: skillId,
            attachments: attachments,
         });
      }
   );

   static readonly FORWARD = new EmailPurpose(
      'FORWARD',
      true,
      WellKnownIconsEnum.EMAILING_FORWARD.icon,
      'samwin.email_dialog.email.title',
      'samwin.email_dialog.email.info_text',
      (store, skillId) => {
         return of(store.selectSnapshot(SamwinSkillsState.getSkill(skillId)).skillConfiguration.emailTemplates);
      },
      (
         store: Store,
         emailService: EmailsService,
         mailTemplate: EmailTemplateRemoteDto,
         connectorId: number,
         call: SamwinCallInfoRemoteDto,
         skillId: number,
         context: any,
         attachments: Array<AttachmentRemoteDto>
      ) => {
         return emailService.sendEmail({
            connectorId: connectorId,
            from: mailTemplate.from,
            to: mailTemplate.to.split(';'),
            cc: mailTemplate.cc.split(';'),
            bcc: mailTemplate.bcc.split(';'),
            body: mailTemplate.body,
            subject: mailTemplate.subject,
            callId: call?.callId ?? 0,
            queueId: skillId,
            attachments: attachments,
         });
      }
   );

   private constructor(
      public name: string,
      public requireCall: boolean,
      public titlebarIcon: IconDefinition,
      public titlebarText: string,
      public infoText: string,
      public emailTemplateRequest: (
         store: Store,
         skill: number,
         emailsService: EmailsService,
         contextData: any
      ) => Observable<EmailTemplateShortInfoRemoteDto[]>,
      public sendEmailTemplate: (
         store: Store,
         emailsService: EmailsService,
         template: EmailTemplateRemoteDto,
         connectorId: number,
         callerInfo: SamwinCallInfoRemoteDto,
         skillId: number,
         contextData: any,
         attachments: Array<AttachmentRemoteDto>
      ) => Observable<any>
   ) {
      super();
   }
}
